import React from "react";
import propTypes from "prop-types";
import { Nav, NavItem, NavLink } from "reactstrap";

export const ChooseTimestamp = ({ lastDate, handleChange }) => {
  const setNewTimestamp = (timestamp) => {
    handleChange({ lastDate: timestamp, isLoading: true });
  };

  return (
    <div>
      <Nav tabs>
        <NavItem>
          <NavLink
            className={lastDate === "minute" ? "active" : ""}
            onClick={() => setNewTimestamp("minute")}
          >
            Last Minute
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={lastDate === "hour" ? "active" : ""}
            onClick={() => setNewTimestamp("hour")}
          >
            Last Hour
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={lastDate === "day" ? "active" : ""}
            onClick={() => setNewTimestamp("day")}
          >
            Last Day
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={!lastDate ? "active" : ""}
            onClick={() => setNewTimestamp(null)}
          >
            All Time
          </NavLink>
        </NavItem>
      </Nav>
    </div>
  );
};

ChooseTimestamp.propTypes = {
  lastDate: propTypes.string,
  handleChange: propTypes.func.isRequired,
};

ChooseTimestamp.defaultProps = {
  lastDate: null,
};
